import { addCss, addScript } from './utils'

/*
 *让 IE 也能执行 console.log
 */
const w = window
if (!w['console']) {
  let newConsole = {}
  w.console = {}
  let forObj = function (obj) {
    let forHtml = ''
    if (typeof obj === 'object') {
      for (let i in obj) {
        forHtml += '{' + i + ':' + forObj(obj[i]) + '}'
      }
    } else {
      forHtml = obj
    }
    return forHtml
  }
  newConsole.log = function (msg) {
    let body = document.getElementsByTagName('body')[0]
    let newChild = document.createElement('consoleNode')
    let newMsg = 'error'
    if (typeof msg === 'string') {
      newMsg = msg
    } else if (typeof msg === 'object') {
      newMsg = ''
      newMsg = forObj(msg)
    }
    newChild.style.display = 'none'
    newChild.innerText = newMsg
    body.appendChild(newChild)
  }
  w.console = newConsole
}

/**
 * 登录模块
 */
let ucenterUI = null
export const showLoginBox = ({
  embedded,
  loginCallback,
  oauthCallback,
  type
}) => {
  type = type || ''
  const init = () => {
    if (!ucenterUI) {
      ucenterUI = new UCenterUI({
        embedded,
        // 登陆成功
        loginCallback (json) {
          ucenterUI.userModal.hide(1000)
          loginCallback(json)
        },
        // 第三方登陆成功
        oauthCallback (json) {
          ucenterUI.userModal.hide(1000)
          oauthCallback()
        }
      })
    }
    ucenterUI.userModal.show(type)
    if (type === 'register') {
      ucenterUI.userModal.userModal_register.find('.J_imgCaptcha').trigger('click')
      // userModal_register.find('.J_imgCaptcha').trigger('click')
    }
  }
  if (typeof UCenterUI === 'undefined') {
    loadUCenterUI().then(() => {
      init()
    })
  } else {
    init()
  }
}

function loadUCenterUI () {
  const url = {
    jquery: '//cdn.jin10.com/assets/js/libs/jquery-1.11.1.min.js',
    rsa: '//cdn.jin10.com/assets/js/plugins/rsa.js',
    ucenterUI: '//cdn.jin10.com/assets/js/ucenterUI/main.js',
    css: '//cdn.jin10.com/assets/css/ucenterUI.css'
  }
  const ucenterUI = (cb) => {
    if (typeof UCenterUI !== 'undefined') {
      cb()
      return false
    }
    addScript(url.rsa, () => {
      addScript(url.ucenterUI, () => {
        addCss(url.css).then(() => {
          cb()
        })
      })
    })
  }
  return new Promise((resolve, reject) => {
    if (!window.$ && !window.jQuery) {
      addScript(url.jquery, () => {
        ucenterUI(resolve)
      })
    } else {
      ucenterUI(resolve)
    }
  })
}

export const device = (() => {
  let ua = navigator.userAgent
  let isAndroid = /Android\s+([\d.]+)/.test(ua)
  let isIos = /(?:iPad|iPhone).*OS\s([\d_]+)/.test(ua) && !isAndroid
  let isMobile = isAndroid || isIos
  let isWeixin = /micromessenger/.test(ua.toLowerCase())
  let isQQ = /QQBrowser/.test(ua)
  let isChrome = ua.toLowerCase().indexOf('chrome') > -1
  return {
    isAndroid,
    isIos,
    isMobile: isAndroid || isIos,
    isWeixin,
    isQQ,
    isChrome
  }
})()



// WEBPACK FOOTER //
// ./src/commons/index.js